<span [ngClass]="frameClass()">
  @if (photoUrl(); as url) { @if (!imageFailed()) {
  <img
    class="size-full object-cover"
    [src]="url"
    [alt]="'Foto de ' + name()"
    (error)="onImageError()"
  />
  } @else {
  <span aria-hidden="true">{{ initials() }}</span>
  } } @else {
  <span aria-hidden="true">{{ initials() }}</span>
  }
</span>
